import { intl } from '@fullstory/intl';
import { NativePlatform } from '@fullstory/proto/fs/api/segment';
import { LabelRule } from '@fullstory/proto/fs/api/pages';

export const platformToLabel: Record<NativePlatform, string> = {
  [NativePlatform.NATIVE_PLATFORM_INVALID]: intl.formatMessage({
    defaultMessage: 'Invalid',
    id: '89T/ze',
  }),
  [NativePlatform.NATIVE_PLATFORM_WEB]: intl.formatMessage({ defaultMessage: 'Web', id: 'B6CB37' }),
  [NativePlatform.NATIVE_PLATFORM_IOS]: intl.formatMessage({ defaultMessage: 'iOS', id: 'OQDKnx' }),
  [NativePlatform.NATIVE_PLATFORM_ANDROID]: intl.formatMessage({
    defaultMessage: 'Android',
    id: 'gQ7kPU',
  }),
};

export const platformsToLabel = (labels: LabelRule[], hasPatterns: boolean) => {
  const platformSet = new Set<NativePlatform>();
  // take the union of label platforms present
  labels.forEach(l => l.platforms.forEach(p => platformSet.add(p.platform)));
  // and if patterns are present, ensure the web platform
  if (hasPatterns) {
    platformSet.add(NativePlatform.NATIVE_PLATFORM_WEB);
  }
  return intl.formatList(
    [...platformSet.values()].map(p => platformToLabel[p]).sort((a, b) => a.localeCompare(b)),
    { type: 'conjunction', style: 'narrow' },
  );
};
